import { derived, get, writable } from 'svelte/store';
import { isNonProductionAppBuild } from 'src/helpers/dev_tools';

const STORAGE_KEY = 'shelly_dev_long_press_edit';

const readInitialValue = (): boolean => {
	if (!isNonProductionAppBuild()) return false;
	try {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === null) return true;
		return stored === 'true';
	} catch {
		return true;
	}
};

/**
 * Dev/staging prototype: touch-and-hold a dashboard widget or list card to enter
 * rearrange / edit mode. Default on for non-production builds; always off in production.
 * Preference is local-only and can be toggled from the Dev Modal.
 */
export const longPressEditEnabled = writable<boolean>(readInitialValue());

longPressEditEnabled.subscribe((value) => {
	if (!isNonProductionAppBuild()) return;
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const longPressEditAvailable = derived(
	longPressEditEnabled,
	($enabled) => isNonProductionAppBuild() && $enabled,
);

export const isLongPressEditAvailable = (): boolean => get(longPressEditAvailable);

export const setLongPressEditEnabled = (enabled: boolean) => {
	longPressEditEnabled.set(isNonProductionAppBuild() ? enabled : false);
};
